import { createHashRouter, createRoutesFromElements, Navigate, Route, useLocation } from 'react-router';

import RouteErrorFallback from '../components/RouteErrorFallback';
import { OriginalLayout } from '../layout/AppLayout';
import VariantStateLayout from '../layout/VariantStateLayout';
import { routes } from './routes';
import { suspendPageLoad } from './suspendPageLoad';

// Lazy load pages for better performance and automatically split the bundle accordingly
const Materials = suspendPageLoad(() => import('../features/materials/Materials'));
const Intro = suspendPageLoad(() => import('../pages/Intro'));
const More = suspendPageLoad(() => import('../pages/More'));
const Graph = suspendPageLoad(() => import('../features/graph/live/LiveGraphPage'));
const GraphConcept = suspendPageLoad(() => import('../features/graph/concept/ConceptGraphPage'));
const LiveGraphLayout = suspendPageLoad(() => import('../features/graph/live/LiveGraphRouteLayout'));
const ConceptGraphLayout = suspendPageLoad(() => import('../features/graph/concept/ConceptGraphLayout'));
const GraphPreview = import.meta.env.DEV
    ? suspendPageLoad(() => import('../features/graph/preview/GraphPreviewPage'))
    : null;
const UserSidebarLoader = suspendPageLoad(() => import('../features/users/userSidebar/UserSidebarLoader'));

const LegacyGraphRedirect = ({ to }: { to: string }) => {
    const { search, hash } = useLocation();
    return <Navigate to={{ pathname: to, search, hash }} replace />;
};

const routesFromElements = createRoutesFromElements(
    <>
        {/* Redirect before mounting data providers so old Concept bookmarks stay local. */}
        <Route path='/relationships' element={<LegacyGraphRedirect to={routes.GRAPH} />} />
        <Route path='/relationships/concept' element={<LegacyGraphRedirect to={routes.GRAPH_CONCEPT} />} />
        {GraphPreview && (
            <Route path='/relationships/preview' element={<LegacyGraphRedirect to={routes.GRAPH_PREVIEW} />} />
        )}
        <Route element={<VariantStateLayout />} errorElement={<RouteErrorFallback />}>
            <Route element={<OriginalLayout />}>
                <Route path={routes.DEFAULT} element={<Intro />} />
                <Route path={routes.MATERIALS} element={<Materials />} />
                <Route path={routes.MORE} element={<More />}>
                    <Route path=':userId' element={<UserSidebarLoader />} />
                </Route>
            </Route>
            <Route element={<LiveGraphLayout />}>
                <Route path={routes.GRAPH} element={<Graph />} />
                {GraphPreview && <Route path={routes.GRAPH_PREVIEW} element={<GraphPreview />} />}
            </Route>
            <Route element={<ConceptGraphLayout />}>
                <Route path={routes.GRAPH_CONCEPT} element={<GraphConcept />} />
            </Route>

            <Route path='*' element={<Navigate to={routes.DEFAULT} />} />
        </Route>
    </>
);

export const router = createHashRouter(routesFromElements);
